export default function ReplacementAndHeight() {
  const checks = [
    "Diagnostic du type de gond et mesure du désaxage au millimètre",
    "Dépose du vantail avec un outillage adapté au poids de l'ouvrant",
    "Retrait de l'ancien gond ou paumelle et nettoyage du logement",
    "Pose du gond neuf avec vissage renforcé dans le dormant",
    "Réglage de hauteur et d'alignement pour un ajustement parfait",
    "Lubrification des points de pivot et test de la manœuvre",
    "Vérification de l'étanchéité du joint et de l'alignement des serrures",
  ];

  return (
    <section className="bg-white py-10 md:py-14 lg:py-16">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-[1280px] mx-auto mx-auto">
          <p className="font-serif italic text-plum-dark text-sm md:text-base mb-3">
            Notre intervention
          </p>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-plum mb-8 leading-tight">
            Remplacement et{" "}
            <span className="font-serif italic">réglage de hauteur</span>
          </h2>

          <div className="space-y-6 text-plum-dark text-base md:text-lg leading-relaxed mb-10">
            <p>
              Le remplacement d'un gond ou d'une paumelle commence par un diagnostic précis. Notre technicien identifie le type de gond : réglable (avec excentrique pour monter/descendre le vantail) ou fixe (à remplacer directement). Il mesure le désaxage au millimètre près pour déterminer si un simple réglage suffit ou si la pièce est trop usée. Sur les fenêtres lourdes (grandes baies, double vitrage épais), il utilise un équipement de levage adapté pour déposer le vantail en toute sécurité sans endommager le dormant ni le vitrage.
            </p>
            <p>
              Une fois le nouveau gond installé, le réglage de hauteur est l'étape la plus délicate. Le vantail doit être parfaitement horizontal et vertical, avec un espacement uniforme entre l'ouvrant et le dormant. Un mauvais réglage fait revenir le frottement en quelques semaines. Nos techniciens vérifient l'alignement à l'aide d'outils de mesure, ajustent l'excentrique du gond si disponible, et testent la manœuvre à plusieurs reprises avant de valider l'intervention. Le résultat : une fenêtre qui s'ouvre et se ferme d'une main, sans bruit, avec une étanchéité optimale.
            </p>
          </div>

          <div className="bg-white rounded-2xl border border-rose-200 p-6 md:p-8">
            <h3 className="font-semibold text-plum text-base md:text-lg mb-5">
              Les étapes de notre remplacement de gond
            </h3>
            <ul className="space-y-3">
              {checks.map((item, i) => (
                <li key={i} className="flex items-start gap-3">
                  <div className="w-6 h-6 rounded-full bg-coral/10 flex items-center justify-center shrink-0 mt-0.5">
                    <i className="ri-check-line text-coral text-sm" />
                  </div>
                  <span className="text-sm md:text-base text-plum-dark">{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}